import './App.css';
import Header from './shared/components/header';
import Home from './module/home';
import Footer from './shared/components/footer';

function App() {
  return (
    <div>
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
